import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  initialize() {
    this.sliderLinks = document.querySelectorAll(".slider-link");
    this.sliderContents = document.querySelectorAll(".slider-content");
  }

  connect() {
    this.sliderSetup();
    this.sliderLinks[0].click();
  }

  sliderSetup() {
    this.sliderLinks.forEach(link => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const selectedslider = link.getAttribute("id");
        const extraClass = link.getAttribute("data-active-class").split(" ")

        // Remove active classes from all sliders
        this.sliderLinks.forEach(l => l.classList.remove(extraClass));
        // Hide all contents
        this.sliderContents.forEach(c => c.classList.add("hidden"));

        // Add active styles to clicked slider
        link.classList.add(extraClass);

        // Show the matching slider content
        const contentToShow = document.querySelector(`#container_${selectedslider}`);
        if (contentToShow) {
          contentToShow.classList.remove("hidden");
        }
      });
    });
  }
}